<template>
  <div class='job'>
    <div class="page-header mb20">
      <div class="page-header-content">
        <div class="header-left" @click="isShowSelectJobDialog=true">{{ jobTitle }}</div>
        <div class="header-search">
          <el-input placeholder="搜索职位、公司" v-model="params.keyword"></el-input>
          <div class="search-btn" @click="search()">搜索</div>
        </div>
        <div class="header-right" @click="isShowFilterJobDialog=true">
          <img src="../../../assets/images/filter-icon.png" alt="">
          <div>筛选</div>
        </div>
      </div>
    </div>
    <div class="page">
      <div class="page-content">
        <div class="content">
          <jobItemPerson :class="{ 'mr0': (index + 1) % 3 == 0 }" v-for="(item, index) in jobs" :key="index" :item="item" @itemClick="goJobDetail"></jobItemPerson>
        </div>
        <el-pagination
          class="page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="params.page"
          :page-sizes="[9, 18, 27, 36]"
          :page-size="params.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <selectJobDialog v-if="isShowSelectJobDialog" @closed="isShowSelectJobDialog=false" @confirm="selectedJob"></selectJobDialog>
    <filterJobDialog v-if="isShowFilterJobDialog" @closed="isShowFilterJobDialog=false" @confirm="filteredJob"></filterJobDialog>
  </div>
</template>

<script>
import jobItemPerson from '@/components/jobItemPerson.vue';
import selectJobDialog from '@/components/selectJobDialog.vue';
import filterJobDialog from '@/components/filterJobDialog.vue'
import { jobseekerIndex, getIndexTotal } from '@/api/jobSeeker'

export default {
  components: {
    jobItemPerson,
    selectJobDialog,
    filterJobDialog,
  },
  data() {
    return {
      jobTitle: '请选择职位',
      params: {
        area_id: 2,
        keyword: "",
        limit: 9,
        page: 1,
      },
      jobs: [],
      total: 0,
      isShowSelectJobDialog: false,
      isShowFilterJobDialog: false,
    }
  },
  methods: {
    getLocation() {
      let cityItemString = localStorage.getItem('jjzl_jobCityId')
      if(cityItemString) {
        this.params.area_id = JSON.parse(cityItemString).id
      } else {
        this.params.area_id = 2 //北京
      }
    },
    goJobDetail(item) {
      this.$router.push({path: 'jobdetail', query: {id: item.id, companyId: item.company_id}})
    },
    // 选择职位回调
    selectedJob(parent, child) {
      this.jobTitle = child.name
      this.isShowSelectJobDialog = false
      this.params.post_id = child.id
      this.params.page = 1
      this.search()
    },
    filteredJob(para) {
      this.params = {
        keyword: "",
        limit: 9,
        page: 1,
      }
      this.getLocation()
      if(Object.keys(para).length) {
        this.params = Object.assign(this.params, para)
      }
      let _ = require('lodash')
      this.params = _.omitBy(this.params, (value) => value === null || value === undefined || (_.isObject(value) && _.isEmpty(value)));
      this.isShowFilterJobDialog = false
      
      this.search()
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getDataList()
    },
    getDataList() {
      this.getLocation()
      jobseekerIndex(this.params).then(res=>{
        if(res.code == 1) {
          this.jobs = res.data
        }
      })

      this.getTotal()
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.params.limit = val
      this.params.page = 1
      this.getDataList()
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.params.page = val
      this.getDataList()
    },
    // 获取总数
    getTotal() {
      let para = JSON.parse(JSON.stringify(this.params))
      delete para.page
      delete para.limit
      getIndexTotal(para).then(res=>{
        if(res.code == 1) {
          this.total = res.data
        }
      })
    }
  },
  created() {
    this.getDataList()
  }
}
</script>

<style lang="less" scoped>
.job {

  .header-left{
    height: 100%;
    position: absolute;
    left: 0;
    font-weight: 500;
    font-size: 23px;
    color: #222222;
    cursor: pointer;
  }
  .header-search {
    width: 867px;
    height: 55px;
    background: #F7F7F7;
    border-radius: 10px 10px 10px 10px;
    display: flex;
    align-items: center;

    .search-btn {
      width: 130px;
      height: 55px;
      line-height: 55px;
      text-align: center;
      background: #2676F7;
      font-size: 17px;
      color: #FFFFFF;
      border-radius: 0 10px 10px 0;
      cursor: pointer;
    }

    /deep/.el-input {
      width: 737px;
      height: 55px;
      margin-top: -30px;
    }
    /deep/.el-input__inner {
      width: 737px;
      height: 55px;
      border: none;
      background-color: #F7F7F7;
      font-size: 20px;
      border-radius: 10px 0px 0px 10px;
    }
  }
  .content {
    display: flex;
    flex-wrap: wrap;

    .mr0 {
      margin-right: 0;
    }
  }
  .header-right {
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    font-size: 17px;
    color: #222222;
    cursor: pointer;

    img{
      width: 20px;
      height: 20px;
      margin-right: 7px;
    }
  }

  .page {
    padding-bottom: 30px;
  }
  /deep/.el-pagination span:not([class*=suffix]){
    font-size: 20px;
  }
  /deep/.el-pagination .el-select .el-input .el-input__inner{
    font-size: 20px;
    width: 130px;
    height: 32px;
  }
  /deep/.el-pagination .el-select .el-input{
    width: 130px;
    height: 32px;
  }
  /deep/.el-pager li{
    font-size: 20px;
  }
  /deep/.el-pagination__editor.el-input .el-input__inner{
    font-size: 20px;
  }
  
}
</style>